/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumMuelleimer: {
    name: 'big-medium-muelleimer';
    data: string;
} = {
    name: 'big-medium-muelleimer',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M103 39H23a5 5 0 0 0 0 10h4.5l7.17 68.2a8.87 8.87 0 0 0 8.95 7.8h40.76a8.87 8.87 0 0 0 9-7.81L100.5 49h2.5a5 5 0 0 0 0-10m-19.49 76h-39l-6.96-66h52.9zM44 34a5 5 0 0 0 5-5v-7c0-6.64 4.3-9 8.33-9h13.34c4 0 8.18 2.3 8.32 8.69A3 3 0 0 0 79 22v7a5 5 0 0 0 10 0v-7c0-11-7.71-19-18.33-19H57.33C47 3 39.39 10.62 39 21.23a5 5 0 0 0 0 .77v7a5 5 0 0 0 5 5"/></svg>`,
};
